<template>
  <label class="toggle-switch" :class="{ 'toggle-switch--checked': isChecked }">
    <input
      type="checkbox"
      :id="id"
      class="toggle-switch__input"
      :checked="isChecked"
      :disabled="disabled"
      :name="name"
      @change="handleChange"
    >
    <span class="toggle-switch__slider"></span>
    <span v-if="showLabel" class="toggle-switch__label">{{ isChecked ? onLabel : offLabel }}</span>
  </label>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      default() {
        return 'toggle-' + Math.random().toString(36).slice(2);
      },
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: null,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    onLabel: {
      type: String,
      default: 'On',
    },
    offLabel: {
      type: String,
      default: 'Off',
    },
  },
  computed: {
    isChecked() {
      return this.modelValue;
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('change', event.target.checked);
    },
  },
};
</script>

<style scoped>
.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.toggle-switch__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-switch__slider {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
  background-color: #ced4da;
  border-radius: 28px;
  transition: background-color 0.25s ease, box-shadow 0.25s ease;
}

.toggle-switch__slider::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 24px;
  height: 24px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: transform 0.25s ease;
}

.toggle-switch__input:checked + .toggle-switch__slider {
  background-color: #28a745;
}

.toggle-switch__input:checked + .toggle-switch__slider::before {
  transform: translateX(24px);
}

.toggle-switch__input:focus + .toggle-switch__slider {
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.3);
}

.toggle-switch__input:disabled + .toggle-switch__slider {
  opacity: 0.6;
  cursor: not-allowed;
}

.toggle-switch__label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #495057;
}
</style>
